export const base64ImageRegExp = new RegExp(/^data:image\/[a-z]+;base64,/)

export const acceptedExtensions = ['jpeg', 'jpg', 'png', 'webp']
